import { useContext } from 'react';
import { AuthContext } from '../../contexts/AuthContext';
export const useHasDocumentsPaidAccessScope = () => {
  const auth = useContext(AuthContext);
  return Boolean(auth && auth.user.scopes.includes('documents-paid-access'));
};